{
  "name": "core",
  "ramps": {
    "ink": [
      "#14121A",
      "#2A2838"
    ],
    "metal": [
      "#3B3F4A",
      "#6B7280",
      "#A9B0BC"
    ],
    "paper": [
      "#F2F0E6"
    ],
    "skinA": [
      "#C98E66",
      "#F0C19A"
    ],
    "skinB": [
      "#7D4A2E",
      "#B5774E"
    ],
    "skinC": [
      "#3A2416",
      "#5C3A24"
    ],
    "fire": [
      "#B5311A",
      "#F2701D",
      "#FFC23D",
      "#FFF4C2"
    ],
    "blood": [
      "#8E1F2B"
    ],
    "playerAccent": [
      "#FFB000"
    ],
    "enemyAccent": [
      "#A83A32"
    ],
    "phosphor": [
      "#7CFF6B"
    ],
    "boot": [
      "#1E1B22",
      "#35303A"
    ],
    "canvas": [
      "#6B6A4E",
      "#8C8A66",
      "#ADA97F"
    ],
    "smoke": [
      "#8A8E93",
      "#BDC0BE",
      "#E4E3DA"
    ]
  }
}
